import { ApiTypes, api } from "../common";
import { MapOfBrandsResponse } from "~src/types/brandMapping";

const PRODUCT_PATHS: ApiTypes.API = {
  brandMapping: {
    path: `api/products/shopify-products/brand-ad/`,
    method: ApiTypes.HTTPMethod.POST,
  },
  brandMappingV2: {
    path: `api/products/shopify-products/brand-ad-v2/`,
    method: ApiTypes.HTTPMethod.POST,
  },
  brandMappingV3: {
    path: `api/products/shopify-products/brand-ad-v3/`,
    method: ApiTypes.HTTPMethod.POST,
  },
};

//----------------------------------------------------------------

export const brandMapping = async (
  searchText: string | undefined,
  page?: number,
) => {
  const endpoint = PRODUCT_PATHS.brandMapping;

  const response = await api<MapOfBrandsResponse>({
    method: endpoint.method,
    url: endpoint.path,
    data: { search_text: searchText, page: page },
  });
  return response.data;
};

export const brandMappingV2 = async (
  searchText: string | undefined,
  page?: number,
  brandToRemove?: number[],
) => {
  const endpoint = PRODUCT_PATHS.brandMappingV2;

  const response = await api<MapOfBrandsResponse>({
    method: endpoint.method,
    url: endpoint.path,
    data: {
      search_text: searchText,
      page: page,
      page_size: 100,
      exclude_brand_ids: brandToRemove,
    },
  });
  return response.data;
};

export const brandMappingV3 = async (
  searchText: string | undefined,
  page?: number,
  brandToRemove?: number[],
) => {
  const endpoint = PRODUCT_PATHS.brandMappingV3;

  const response = await api<MapOfBrandsResponse>({
    method: endpoint.method,
    url: endpoint.path,
    data: {
      search_text: searchText,
      page: page,
      exclude_brand_ids: brandToRemove,
    },
  });
  return response.data;
};
